import { useContext } from 'react'
import { PlatformRoleContext } from '@/contexts/platform-role-context'

export function usePlatformRoleContext() {
  const ctx = useContext(PlatformRoleContext)
  if (!ctx) throw new Error('usePlatformRoleContext must be used within PlatformRoleProvider')
  return ctx
}
